import { PropsWithChildren } from 'react';

import { css, cx } from '@emotion/css';
import { Modal, Row } from 'antd';
import { Display, Spacing } from 'src/styles';

import { MSpinner } from '../MSpinner/MSpinner';

const modalTitleStyle = css`
  ${Display.block}
  width: 100%;
`;

const modalFooterStyle = css`
  ${Display.block}
  width: 100%;
`;

const modalBodyStyle = css`
  ${Spacing.p24}
  ${Display.block}
  width: 100%;
`;

const singlePageModalStyle = css`
  .ant-modal-body {
    padding: 0 !important;
  }
`;

export const MModalTitle = ({ children }: PropsWithChildren) => {
  return (
    <Row className={cx('ant-modal-header', modalTitleStyle)}>
      <div className='ant-modal-title'>{children}</div>
    </Row>
  );
};

interface MModalBodyProps {
  height?: number;
  isLoading?: boolean;
}

export const MModalBody = ({ children, height, isLoading }: PropsWithChildren<MModalBodyProps>) => {
  return (
    <Row className={cx(modalBodyStyle)} style={{ height }}>
      {isLoading ? <MSpinner height={`${height ?? 600}px`} /> : children}
    </Row>
  );
};

interface MModalFooterProps {
  className?: string;
}

export const MModalFooter = ({ children, className }: PropsWithChildren<MModalFooterProps>) => {
  return <Row className={cx('ant-modal-footer', modalFooterStyle, className)}>{children}</Row>;
};

export type SinglePageModalProps = {
  open: boolean;
  onClose?: () => void;
  width?: number;
  height?: number;
  className?: string;
  maskClosable?: boolean;
  closable?: boolean;
  centered?: boolean;
  content: React.ReactNode;
  testId?: string;
};

export const SinglePageModal = ({
  open,
  onClose,
  width,
  maskClosable,
  closable = true,
  centered = true,
  content,
  className = '',
  testId = '',
}: SinglePageModalProps) => {
  return (
    <Modal
      width={width}
      destroyOnClose
      centered={centered}
      open={open}
      onCancel={onClose}
      closable={closable}
      className={cx(singlePageModalStyle, className)}
      maskClosable={maskClosable}
      data-testid={`single-page-modal-${testId}`}
      footer={null}>
      {content}
    </Modal>
  );
};
